import { StudentSummaryTab } from '@features/student-page/components/StudentSummaryTab'
import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { Suspense } from 'react'

export const Route = createFileRoute('/_layout/students/$studentNo/summary')({
  component: RouteComponent,
  staticData: {
    crumb: {
      label: 'Summary',
    }
  }
})

function RouteComponent() {

    const { studentNo } = Route.useParams()

    return (
        <QueryErrorBoundary title='Failed to load student summary'>
            <Suspense fallback={<LoadingIndicator resource='student summary'/>}>
                <StudentSummaryTab studentNo={studentNo} />
            </Suspense>
        </QueryErrorBoundary>
    )
}
